<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-6-retrovirus-recall">
<h1>Chapter 6<br/> Retrovirus Recall</h1>
<div class="section level2" id="langley-virginia-two-years-ago">
<h2>Langley, Virginia: Two Years Ago</h2>
<p>Internal Memo</p>
<p style="text-indent:00em;">Central Intelligence Agency</p>
<p style="text-indent:00em;">Designation: Classified—Top Secret</p>
<p style="text-indent:00em;">To: Director Norman Miller</p>
<p style="text-indent:00em;">From: James Bowie</p>
<p style="text-indent:00em;">CC:</p>
<p style="text-indent:00em;">Subject: Emergency Action Required</p><br/>
<p style="text-indent:00em;">Mr. Director,</p>
<p>Urgent intervention needed. Agent Justin Booker of our special counterinsurgency operation, code named ‘Retrovirus’, has reportedly become increasingly unstable. Per our intelligence reports, while on his current assignment in Iraq, he recently led a group of ISIL operatives in a daytime attack on an allied military outpost. British intelligence corroborates this and reports that six British soldiers were wounded and three were killed along with two Kurds.</p>
<p>I fear that in his efforts to garner favor within ISIL, he’s resorted to operations involving attacking our allies. While the merits of this approach may be arguable if they turn out to be successful in expanding his scope of influence, these tactics fall outside the parameters of this mission and pose a direct threat to our relationships with cooperating nations.</p><br/>
<p>For the sake of Operation Retrovirus and its legacy, I therefore recommend the immediate extraction of Agent Booker by a special operations unit followed by extensive debriefing and possible expulsion from the program.</p>
<p style="text-indent:00em;">Sincerely,</p>
<p style="text-indent:00em;">James Bowie, Special Projects Team Leader</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch010.vue?6d1f04af